import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "status-check-double",
  "use": "status-check-double-usage",
  "viewBox": "0 0 14 7",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 7\" id=\"status-check-double\"><path d=\"m5.885 3.9 1.393 1.334 5.406-5.18.954.915-6.34 6.07-.412-.39L4.95 4.796 2.658 6.993l-.41-.393-.002.002L0 4.452l.936-.897 1.7 1.63 5.41-5.18L9 .92 5.883 3.9zm0 0-.31-.296-.935.897.31.3.935-.896z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol